module.exports = __webpack_public_path__ + "media/images/lb/184-90f2429d4b9f79a2be0a0de124e4147c.svg";